import React, { useContext } from 'react'
import { useWindowSize } from 'react-use'
import { getAssociatedStickers, webFetch } from 'shared/api'
import GifContext from 'shared/components/context/gif'
import Grid from 'shared/components/grid'
import StickerAttributionGridOverlay from 'shared/components/sticker-attribution/grid-overlay-attribution'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import GAEventContext from '../context/ga-events'

const AttributionGrid = ({ gif, columns, overrideWidth }) => {
    const { receivedGifs } = useContext(GifContext)
    const { onStickerAttributionChannelClick } = useContext(GAEventContext)
    const { width } = useWindowSize()

    const handleRelatedGrid = async offset => {
        const relatedResults = await webFetch.related(gif.id, { offset })
        const { data: gifs = [] } = relatedResults
        receivedGifs({ gifs })
    }

    const onGAClick = gif => {
        googleAnalyticsEvent({
            category: 'GIF Detail',
            action: 'Credits Grid Media Click',
            label: gif.id,
        })
    }

    const fetchUsedStickers = async offset => {
        handleRelatedGrid(offset)
        const result = await getAssociatedStickers(gif.id)
        result.pagination = {
            count: result.data.length,
            offset: 0,
            total_count: result.data.length,
        }
        result.data = result.data.filter(gif => gif.is_sticker)

        return result
    }

    return (
        <Grid
            noRedux={true}
            fetchGifs={offset => fetchUsedStickers(offset)}
            width={overrideWidth || width}
            Overlay={StickerAttributionGridOverlay}
            columns={columns}
            onGifGAClick={gif => onGAClick(gif)}
            onAttributionClick={onStickerAttributionChannelClick}
        />
    )
}

export default AttributionGrid
